module.exports = __webpack_public_path__ + "img/content3_1.c9737de9.png";